<template>
  <div class="contain"
       v-loading="loading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="contain" id="container"></div>

    <div class="absoluteClass">
      <div style="width: 60%; display: flex;flex-direction: row;justify-content: space-between;">
        <el-button icon="el-icon-place" type="primary" plain @click="resetFlowCount"> 复位 </el-button>
        <div class="searchDivClass">
          <el-input v-model="search" placeholder="请输入节点名称" @keyup.enter.native="searchFlowCount">
            <el-button slot="append" icon="el-icon-search" @click="searchFlowCount">搜索</el-button>
          </el-input>
        </div>
      </div>
      <el-button v-if="afterClickShow" icon="el-icon-s-fold" @click="drawerStatus = true"></el-button>
    </div>
<!--    <div class="positionLeft">-->
<!--      <el-button icon="el-icon-place" type="primary" plain @click="resetFlowCount"> 复位 </el-button>-->
<!--    </div>-->
<!--    <div class="positionRight">-->
<!--      <el-button v-if="!drawerStatus" icon="el-icon-s-fold" @click="drawerStatus = true"></el-button>-->
<!--    </div>-->

    <div class="aaa">
      <el-drawer
        :visible.sync="drawerStatus"
        size="50%"
        @close="closeDrawer"
        direction="rtl"
        :modal="false"
      >
        <template slot="title">
          <!--          <button><i class="el-icon-s-unfold"></i></button>-->
          <div class="drawerHeader">
            <el-button icon="el-icon-s-unfold" @click="drawerStatus = false"></el-button>
            <span>{{ drawerName }}</span>
          </div>
        </template>
        <div>
          <div>介绍：{{ info }}</div>
          <div v-if="gongShi != null">
            公式：
            <TheLatex2Math :latex="gongShi" v-if="gongShi != null"></TheLatex2Math>
          </div>
        </div>
        <div v-for="(item, index) in paramList" :key="index">
          <div>
            <div><span style="font-weight: bold">参数：</span>{{ item.name }} ({{ item.alias }})</div>
            <div v-show="item.value != null && item.value != '请输入'">
              <span style="font-weight: bold">值：</span>{{ item.value }}
            </div>
            <div v-show="item.origin">
              <span style="font-weight: bold">来源：</span>
              <el-link type="primary" @click="openOrigin(item)"
              >{{ item.origin }}
              </el-link>
            </div>
          </div>
          <br/>
        </div>
        <div>
          <!--          最终结果为：<span> {{ jieGuo }} </span>-->
        </div>
      </el-drawer>
    </div>
    <div>
      <el-dialog
        :title="dialogName"
        :visible.sync="dialogStatus"
        width="40%"
        class="dialogClass"
        @close="dialogClose"
      >
        <template slot="title">
          <span>{{ dialogName }}</span>
          <el-button size="small" icon="el-icon-edit" plain type="primary"
                     @click="isSetParamValue = !isSetParamValue"> {{ isSetParamValue ? "返回" : "编辑值来源" }}
          </el-button>
        </template>
        <div v-if="isSetParamValue">
          <el-form ref="form" label-width="120px">
            <el-form-item label="参数值" required>
              <el-input v-model="dialogParamValue" placeholder="请输入数字"></el-input>
            </el-form-item>
            <el-form-item label="参考来源" required>
              <el-input v-model="dialogOrigin" placeholder="请输入一个http链接，例如（https://www.baidu.com/）"></el-input>
            </el-form-item>
            <el-form-item label="依据描述" required>
              <el-input
                type="textarea"
                :autosize="{ minRows: 2 }"
                placeholder="请输入内容"
                v-model="dialogAnalysisProcess"
              >
              </el-input>
            </el-form-item>

          </el-form>
          <div class="submitClass" style="margin-top: 10px">
            <el-button type="primary" @click="updateParamInfo">
              确定
            </el-button>
          </div>
        </div>

        <div v-else v-for="(item, index) in dialogList" :key="index">
          <div style="margin-top: 10px">
            <span style="font-weight: bold">来源{{ index + 1 }}：</span>
            <p style="color: #0a84ff;cursor: pointer;margin: 0;display: contents;" @click="openOrigin(item)">{{ item.origin }}，</p>
            <span style="font-weight: bold">值为：</span>
            <span @click="updateParamValue(item)" style="color: red; cursor: pointer">{{ item.value }}</span>
          </div>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog title="新增参数" :visible.sync="addChildrenNodeStatus" width="40%" class="dialogClass">
        <el-form ref="form" label-width="120px">
          <el-form-item label="参数名称" required>
            <el-input v-model="addNodeName" placeholder="请输入节点名称"></el-input>
          </el-form-item>
          <el-form-item label="参数别名" required>
            <el-input v-model="addNodeAlias" placeholder="请输入参数别名(例如:R1)"></el-input>
          </el-form-item>
          <el-form-item label="参数值" required>
            <el-input v-model="addNodeValue" placeholder="请输入数字"></el-input>
          </el-form-item>
          <el-form-item label="计算公式描述" required>
            <el-input v-model="addNodeRestExpression" placeholder="请输入公式的描述"></el-input>
          </el-form-item>
          <el-form-item label="计算公式" required>
            <el-input v-model="addNodeGongShi" placeholder="请输入公式(变量需要与参数别名一致)"></el-input>
          </el-form-item>
          <el-form-item label="参考来源">
            <el-input v-model="addNodeOrigin" placeholder="请输入一个http链接，例如（https://www.baidu.com/）"></el-input>
          </el-form-item>
          <el-form-item label="依据描述" required>
            <el-input
              type="textarea"
              :autosize="{ minRows: 2 }"
              placeholder="请输入内容"
              v-model="addNodeAnalysisProcess"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveCurrentNode" size="small">确 定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <div>
      <el-dialog title="修改公式" :visible.sync="updateNodeGongShiStatus" width="40%" class="dialogClass">
        <el-form ref="form" label-width="120px">
          <el-form-item label="计算公式描述" required>
            <el-input v-model="updateNodeRestExpression" placeholder="请输入公式的描述"></el-input>
          </el-form-item>
          <el-form-item label="计算公式" required>
            <el-input v-model="updateNodeGongShi" placeholder="请输入公式(变量需要与参数别名一致)"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="updateNodeGongShiMethod" size="small">确 定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <div>
      <el-dialog :title="pdfName" :visible.sync="pdfStatus" width="60%" class="dialogClass">
        <div>
          <iframe :src="pdfUrl" type="application/pdf" width="100%" height="800px"/>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import userapi from "@/api/user";
import modelApi from "@/api/model";
//import jsonData from "../../数据格式.json";
import TheLatex2Math from './MathJax/gs.vue'
import G6 from "@antv/g6";


export default {
  components: {TheLatex2Math},
  props: {},
  data() {
    return {
      addChildrenNodeStatus: false,
      updateNodeGongShiStatus: false,
      addCurrentNode: null,
      updateCurrentNode: null,
      addNodeAnalysisProcess: null,
      addNodeOrigin: null,
      addNodeValue: null,
      addNodeAlias: null,
      addNodeName: null,
      addNodeGongShi: null,
      addNodeRestExpression: null,
      updateNodeRestExpression: null,
      updateNodeGongShi: null,

      search: "", //搜索

      menu: null,

      /**
       * pdf 参数
       */
      pdfStatus: false,
      pdfName: null, // pdf名字
      pdfUrl: null, // pdf的url

      loading: false, //是否加载
      graph: null,
      edges: null,
      nodes: null,
      afterClickShow: false,
      drawerStatus: false,
      dialogStatus: false,
      drawerName: null,
      dialogName: null,
      dialogParamValue: "",
      dialogOrigin: null,
      dialogAnalysisProcess: null,
      gongShi: null,
      info: null,
      jieGuo: null,
      paramList: [
        /*{name: "参数1", value: 1.35, origin: "****第12页"},
        {name: "参数2", value: 3.2, origin: "****第15页"},
        {name: "参数3", value: 4.3, origin: "****第17页"}*/
      ],
      drawerNode: null,
      dialogNode: null,
      dialogList: [
        /* {origin: "<<***>>第十页",value: 1.58},
        {origin: "<<***>>第十页",value: 1.85},
        {origin: "<<***>>第十页",value: 1.32}*/
      ],
      data: [],
      isSetParamValue: false,
      number: 1,
      showResultStatus: false,
      showResult: true,
      colorArray: [],
      paramId: -1,
    };
  },
  methods: {
    /**
     * 根据输入的节点名称 搜索节点
     */
    searchFlowCount() {
      let data = this.graph.save();
      let arr = [];
      let node;
      let sea = this.search;

      function iterateTreeData(data) {
        data.children.forEach(child => {
          // 处理每个节点
          console.log("child",child.name,sea); // 这里可以访问节点的所有属性
          if (child.name.includes(sea)) {
            arr.push(child);
            return;
          }
          // 如果节点有子节点，递归调用
          if (child.children && child.children.length > 0) {
            iterateTreeData(child);
          }
        });
      }
      iterateTreeData(data);

      if (arr.length > 0) {
        node = arr[0];
      }

      if (node) {
        this.iterateTreeCollapsed(node);
        this.initShowResult();
        this.graph.render();
        this.graph.zoomTo(1);
        this.graph.moveTo(400 - 300 * node.depth, 150 - node.y, {animate: true});
      }
    },
    iterateTreeCollapsed(data) {
      if (data.depth !== 0){
        let parNode = this.graph.findDataById(data.pid);
        parNode.collapsed = false;
        this.iterateTreeCollapsed(parNode)
      }
    },
    /**
     * 画布复位
     */
    resetFlowCount() {
      let nodes = this.graph.getNodes().map((node) => node.getModel());
      let nodeModel;
      nodes.forEach((node) => {
        if (node.depth === 0){
          nodeModel = node
        }
        if (node.depth === 1){
          node.collapsed = true;
        }
      });
      // 修改第二层节点的展开状态 然后 渲染画布
      this.graph.render();
      // 画布渲染后 调整中心位置
      this.graph.zoomTo(1);
      this.graph.moveTo(400 - 300 * nodeModel.depth, 150 - nodeModel.y, {animate: true});
    },

    /**
     * 对话框关闭时 重置参数
     */
    dialogClose() {
      this.dialogParamValue = null;
      this.dialogOrigin = null;
      this.dialogAnalysisProcess = null;
    },
    /**
     * 修改公式
     */
    updateNodeGongShiMethod() {
      modelApi.addParameterSource({
        fname: this.updateCurrentNode.name,
        desc: this.updateNodeRestExpression,
        formula: this.updateNodeGongShi
      }).then((res) => {
        if (res.data.status == 200) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          //修改节点的 计算公式 和 描述表达式
          this.updateCurrentNode.gongShi = this.updateNodeGongShi;
          this.updateCurrentNode.restExpression = this.updateNodeRestExpression;
          this.graph.updateItem(this.updateCurrentNode.id, this.updateCurrentNode)

          this.updateNodeGongShiStatus = false;

          this.initShowResult();
          this.graph.render();
          this.graph.zoomTo(1);
          this.graph.moveTo(400 - 300 * this.updateCurrentNode.depth, 150 - this.updateCurrentNode.y, {animate: true});
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
          });
        }
      })
    },
    /**
     * 判断字符串是否为null或者空
     */
    isNotEmpty(...strings) {
      for (let str of strings) {
        if (str == null || str == '') {
          return false;
        }
      }
      return true;
    },
    /**
     * 给当前节点添加子节点数据
     */
    saveCurrentNode() {
      //当前节点 this.addCurrentNode
      let checkNull = this.isNotEmpty(this.addNodeName, this.addNodeAlias, this.addNodeRestExpression, this.addNodeGongShi, this.addNodeAnalysisProcess, this.addNodeValue);
      if (!checkNull) {
        this.$message({
          message: "参数名称，参数别名，参数值，计算公式描述，计算公式，依据描述是必填项",
          type: "warning",
        });
        return;
      }
      let isNumber = !isNaN(parseFloat(this.addNodeValue)) && isFinite(this.addNodeValue);
      if (!isNumber) {
        this.$message({
          message: "参数值必须是数字",
          type: "warning",
        });
        return;
      }

      let origin = this.addNodeOrigin == null ? "" : this.addNodeOrigin

      modelApi.addParameterSource({
        fname: this.addCurrentNode.name,
        param: this.addNodeName,
        nm: this.addNodeAlias,
        value: parseFloat(this.addNodeValue), //判断是否是数值
        desc: this.addNodeRestExpression,
        formula: this.addNodeGongShi,
        origin: this.addNodeAnalysisProcess + " 链接：" + origin ,
        who: null,
      }).then((res) => {
        if (res.data.status == 200) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
        }
        let dependent = [];
        dependent.push({
          desc: this.addNodeAnalysisProcess + " 链接：" + origin,
          value: parseFloat(this.addNodeValue)
        });
        let childrenParam = {
          id: this.addCurrentNode.id + "-" + (this.addCurrentNode.children.length + 1),
          pid: this.addCurrentNode.id,
          name: this.addNodeName + "(" + this.addNodeAlias + ")",
          info: this.addNodeName + "(" + this.addNodeAlias + ")",
          alias: this.addNodeAlias,
          param: this.addNodeName,
          paramValue: parseFloat(this.addNodeValue),
          status: this.addCurrentNode.id,
          otherData: dependent,
          origin: this.addNodeAnalysisProcess + " 链接：" + origin,
        };
        //将节点设置为 展开状态
        this.addCurrentNode.collapsed = false;
        this.addCurrentNode.gongShi = this.addNodeGongShi;
        this.addCurrentNode.restExpression = this.addNodeRestExpression;
        this.graph.updateItem(this.addCurrentNode.id, this.addCurrentNode)

        this.graph.addChild(childrenParam, this.addCurrentNode.id);
        this.addChildrenNodeStatus = false;
        this.initShowResult();
        this.graph.render();
        this.graph.zoomTo(1);
        this.graph.moveTo(400 - 300 * this.addCurrentNode.depth, 150 - this.addCurrentNode.y, {animate: true});
      })
    },
    openOrigin(item) {
      console.log("item", item);
      if (item.origin.indexOf("链接：") != -1) {
        //包含连接  尝试打开连接
        let index = item.origin.indexOf("链接：");

        userapi.getRequest("/chachong/canOpen",{url: item.origin.substring(index + 3)}).then((res) =>{
          if(res.data){
            window.open(item.origin.substring(index + 3));
          }else {
            window.open(item.data.trim());
            // window.open("http://127.0.0.1:10086/file/%E4%B8%AD%E5%9B%BD%E6%B5%B7%E6%B2%B3%E6%B5%81%E5%9F%9F%E6%B2%B3%E9%81%93%E5%A4%96%E6%A4%8D%E8%A2%AB%E7%94%9F%E6%80%81%E9%9C%80%E6%B0%B4%E9%87%8F%E6%A6%82%E5%86%B5%20%E5%BC%80%E6%BA%90%E5%9C%B0%E7%90%86%E7%A9%BA%E9%97%B4%E5%9F%BA%E9%87%91%E4%BC%9A%E4%B8%AD%E6%96%87%E5%88%86%E4%BC%9A%20%E5%BC%80%E6%94%BE%E5%9C%B0%E7%90%86%E7%A9%BA%E9%97%B4%E5%AE%9E%E9%AA%8C%E5%AE%A4.html");
          }
        })
      } else {
        if (item.data) {
          modelApi.find_source({
            desc: item.origin,
            data: item.data.replace(" ", "").replace("\"", ""),
          }).then((res) => {
            if (res.data.code != 500) {
              // 创建二进制文件
              let blob = new Blob([res.data], {type: 'application/pdf'});
              const fileUrl = URL.createObjectURL(blob)
              this.pdfName = item.origin
              this.pdfUrl = fileUrl
              this.pdfStatus = true
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            }
          })
        }
      }
    },
    /**
     * 深度为3的节点 鼠标移入移出时 相同节点的颜色改变和取消
     * @param id
     * @param status  判断移入还是移出
     */
    depthThreeSameNodeActive(id, status) {
      let node = this.graph.findById(id).getModel();
      this.nodes.forEach((item) => {
        if (item.depth == 3 && item.name == node.name && item.id != node.id) {
          let nodeShape = this.graph
            .findById(node.id)
            .getContainer()
            .find((child) => child.get("name") === "rect-shape");
          let sameShape = this.graph
            .findById(item.id)
            .getContainer()
            .find((child) => child.get("name") === "rect-shape");
          if (status) {
            nodeShape.attr("fill", "#11B926FF");
            sameShape.attr("fill", "#11B926FF");
          } else {
            nodeShape.attr("fill", "#fff");
            sameShape.attr("fill", "#fff");
          }
        }
      });
    },
    /**
     * 判断这个节点下的参数是否都有值  有==> true 否则 false
     * @param item
     * @returns {boolean}
     */
    hasParamValueAndAliasSameGongShi(item) {
      let aliasList = []
      for (let child of item.children) {
        if (child.paramValue === "请输入") {
          return false;
        }
        aliasList.push(child.alias)
      }
      // 公式里面是否包含 所有参数的别名
      for (let alias of aliasList) {
        if (!item.gongShi.includes(alias)) {
          return false;
        }
      }
      return true;
    },
    /**
     *  树图初始话的时候就显示结果
     */
    initShowResult() {
      let map = this.graph.getNodes().map((node) => node.getModel());
      map.forEach((item) => {
        if (item.depth == 4) {
          this.graph.removeChild(item.id);
        }
      });
      this.nodes.forEach((item) => {
        if (item.depth == 2 && item.children.length > 0) {
          if (!this.hasParamValueAndAliasSameGongShi(item) || item.gongShi == null) {
            return;
          }
          let param = this.makeParameters(item);
          modelApi.getFormulaCal(param).then((res) => {
            if (res.data.status == 200) {
              //添加结果节点
              let node = {
                id: "result" + item.id,
                pid: item.children[0].id,
                name: item.restExpression + "(" + item.gongShi + ")",
                paramValue: res.data.data,
                label: "result" + item.id,
                status: item.children[0].status,
                yinSu: null,
              };
              this.graph.addChild(node, item.children[0].id);

              //添加 参数和结果的连线
              for (let i = 0; i < item.children.length; i++) {
                if (i != 0) {
                  let drawerEdge = {
                    id: item.children[i].id + ":" + "result" + item.id,
                    source: item.children[i].id,
                    target: "result" + item.id,
                  };
                  this.graph.addItem("edge", drawerEdge);
                }
              }
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            }
          }).catch()

        }
      });
    },
    makeParameters(item) {
      let param = {
        expression: item.gongShi,
        variable_dict: {}
      };
      item.children.forEach(child => {
        if (item.gongShi.includes(child.alias)) {
          param.variable_dict[child.alias] = child.paramValue
        }
      })
      return param;
    },
    /**
     * 自定义参数的值，来源，分析依据
     */
    updateParamInfo() {
      let isNumber = !isNaN(parseFloat(this.dialogParamValue)) && isFinite(this.dialogParamValue);
      const regex = new RegExp("^(http|https):\\/\\/[a-zA-Z0-9\\-\\.]+\\.[a-zA-Z]{2,}(\\/\\S*)?$")
      let isValidUrl = regex.test(this.dialogOrigin);

      let isEmpty = this.dialogAnalysisProcess == null || this.dialogAnalysisProcess == "" || this.dialogAnalysisProcess == undefined ? false : true;

      console.log("isEmpty",isEmpty,"isValidUrl",isValidUrl)

      if (!isNumber || !isValidUrl || !isEmpty) {
        this.$message({
          message: "输入正确的内容",
          type: "warning",
        });
        return;
      }

      /**
       * 修改弹窗显示的信息
       * @type {null}
       */
      this.dialogNode.otherData.push({
        desc: this.dialogAnalysisProcess + " 链接：" + this.dialogOrigin,
        value: parseFloat(this.dialogParamValue),
      });
      /**
       * 修改抽屉里面的值
       */
      this.paramList.forEach((i) => {
        for (let key in i) {
          if (key == this.drawerName) {
            i.value = parseFloat(this.dialogParamValue);
            i.origin = this.dialogOrigin;
          }
        }
      });

      //修改节点的参数值
      this.dialogNode.paramValue = Number.parseFloat(this.dialogParamValue);
      this.dialogNode.origin = this.dialogOrigin;

      this.graph.render();

      this.initShowResult();

      modelApi
        .addParameterSource({
          param: this.dialogNode.param,
          nm: this.dialogNode.alias,
          value: parseFloat(this.dialogParamValue),
          origin: this.dialogAnalysisProcess + " 链接：" + this.dialogOrigin,
          who: null,
        })
        .then((res) => {
          if (res.data.status == 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
          }
        });

      this.isSetParamValue = false;
      this.dialogStatus = false;
      this.graph.zoomTo(1);
      this.graph.moveTo(400 - 300 * this.dialogNode.depth, 150 - this.dialogNode.y, {animate: true});
    },
    /**
     * 修改参数的值
     * @param value
     */
    updateParamValue(item) {
      this.dialogNode.paramValue = item.value;
      this.dialogNode.origin = item.origin;
      this.dialogNode.data = item.data;
      this.dialogStatus = false;
      this.graph.render();
      this.graph.zoomTo(1);
      this.graph.moveTo(400 - 300 * this.dialogNode.depth, 150 - this.dialogNode.y, {animate: true});
    },
    /**
     * 点击参数上的数值 打开弹出框
     * @param id
     */
    openDialog(id) {
      let item = this.graph.findById(id);
      this.dialogNode = item.getModel();
      this.dialogName = this.dialogNode.name;

      this.dialogList = [];
      this.dialogNode.otherData.forEach((i) => {
        if (i.desc != null && i.value != null) {
          this.dialogList.push({
            name: this.dialogNode.name,
            origin: i.desc,
            value: i.value,
            data: i.data,
          });
        }
      });
      // 判断点击的这个节点的paramValue是否有值  有值的话弹窗显示内容，没有值自定义
      if (this.dialogNode.paramValue == "请输入") {
        this.isSetParamValue = true;
      }
      this.dialogStatus = true;
    },

    /**
     * 点击节点打开抽屉
     * @param id
     */
    openDrawer(id) {
      console.log("this.drawerNode",this.drawerNode)
      let item = this.graph.findById(id);
      this.drawerNode = item.getModel();
      this.drawerName = this.drawerNode.name;
      this.gongShi = this.drawerNode.gongShi;
      this.info = this.drawerNode.info;

      // 先删除 这个节点下的（参数）
      let currentNode = this.graph.findDataById(this.drawerNode.id);
      if (currentNode.children.length > 0) {
        console.log("currentNode.children",currentNode.children)
        this.paramList = [];
        currentNode.children.forEach((child) => {
          this.paramList.push({
            name: child.param,
            alias: child.alias,
            value: child.paramValue,
            origin: child.origin,
            data: child.data,
          });
        });
        this.drawerStatus = true;
        return;
      }

      this.loading = true;
      this.afterClickShow = true;
      modelApi
        .getFlowParamAndFormulas({
          question: this.drawerName /*this.drawerName*/,
        })
        .then((res) => {
          console.log("res",res)
          this.paramList = [];
          // let res = jsonData;
          if (res.data.status == 200 && res.data.data.param.length > 0) {
            this.gongShi = res.data.data.retvalue.latex; //res.data.data.retvalue.desc;
            this.drawerNode.gongShi = res.data.data.retvalue.name; //res.data.data.retvalue.desc;
            this.drawerNode.restExpression = res.data.data.retvalue.desc; //res.data.data.retvalue.desc;
            let param = res.data.data.param;
            // let param = res.data.param;
            // [{"参数a": []}, {"参数b": ["0.2", "参数的来源"]}]

            let childrenList = [];

            param.forEach((i, index) => {
              let childrenParam = {
                id: this.paramId-- + "",
                pid: this.drawerNode.id,
                name: i.name + "(" + i.alias + ")",
                info: i.name + "(" + i.alias + ")",
                alias: i.alias,
                param: i.name,
                paramValue: i.dependent[0].value
                  ? parseFloat(i.dependent[0].value)
                  : "请输入",
                status: this.drawerNode.id,
                otherData: i.dependent,
                origin: i.dependent[0].desc ? i.dependent[0].desc : "",
                data: i.dependent[0].data ? i.dependent[0].data : "",
              };
              childrenList.push(childrenParam);
              this.paramList.push({
                name: i.name,
                alias: i.alias,
                value: i.dependent[0].value
                  ? parseFloat(i.dependent[0].value)
                  : null,
                origin: i.dependent[0].desc ? i.dependent[0].desc : null,
                data: i.dependent[0].data ? i.dependent[0].data : null,
              });
            });
            //抽屉里面的参数 数组颠倒
            // this.paramList.reverse();
            //将要添加到画布数组颠倒后在添加到画布中
            /*childrenList.reverse().forEach(item=>{
            this.graph.addChild(item,this.drawerNode.id);
          })*/
            childrenList.forEach((item) => {
              this.graph.addChild(item, this.drawerNode.id);
            });
            this.drawerNode.collapsed = false;
            this.initShowResult();
            // this.graph.render();
            // this.graph.focusItem(this.drawerNode.id)
            this.loading = false;
            this.drawerStatus = true;

            this.graph.zoomTo(1);
            // 使用 'animate' 选项进行平滑过渡
            this.graph.moveTo(400 - 300 * this.drawerNode.depth, 150 - this.drawerNode.y, {animate: true});

          } else if (res.data.status == 200 && res.data.data.param.length == 0) {
            this.loading = false;
            return;
          }else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
            this.loading = false;
            return;
          }
        }).catch((err) => {
        this.loading = false;
      });
    },

    /**
     * 关闭抽屉
     */
    closeDrawer() {
      this.showResult = true;
    },

    /**
     * 用于生成指定长度的颜色数组
     * @param length
     * @returns {*[]}
     */
    generateColorArray(length) {
      let colorArray = [];
      let count = 0;

      while (colorArray.length < length) {
        let color = this.getRandomColor();
        let isSimilar = false;

        // 检查颜色是否相近
        for (let i = 0; i < colorArray.length; i++) {
          if (this.isSimilarColor(color, colorArray[i])) {
            isSimilar = true;
            break;
          }
        }

        // 检查颜色是否为黑白色
        let rgb = this.hexToRgb(color);
        if (rgb.r < 30 && rgb.g < 30 && rgb.b < 30) {
          isSimilar = true;
        }
        if (rgb.r > 225 && rgb.g > 225 && rgb.b > 225) {
          isSimilar = true;
        }

        if (!isSimilar) {
          colorArray.push(color);
        }

        count++;

        // 防止无限循环
        if (count > 1000) {
          break;
        }
      }

      return colorArray;
    },
    /**
     * 用于生成随机颜色
     * @returns {string}
     */
    getRandomColor() {
      let letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    /**
     * 用于判断两个颜色是否相近
     * @param color1
     * @param color2
     * @returns {boolean}
     */
    isSimilarColor(color1, color2) {
      let rgb1 = this.hexToRgb(color1);
      let rgb2 = this.hexToRgb(color2);
      let threshold = 30; // 颜色相似度阈值

      let rDiff = Math.abs(rgb1.r - rgb2.r);
      let gDiff = Math.abs(rgb1.g - rgb2.g);
      let bDiff = Math.abs(rgb1.b - rgb2.b);

      // 判断颜色是否相近以及是否太黑或太白
      return (
        rDiff + gDiff + bDiff < threshold ||
        (rgb1.r < 50 && rgb1.g < 50 && rgb1.b < 50) ||
        (rgb1.r > 200 && rgb1.g > 200 && rgb1.b > 200)
      );
    },
    /**
     * 用于将十六进制颜色转换为RGB颜色
     * @param hex
     * @returns {{r: number, b: number, g: number}}
     */
    hexToRgb(hex) {
      let bigint = parseInt(hex.slice(1), 16);
      let r = (bigint >> 16) & 255;
      let g = (bigint >> 8) & 255;
      let b = bigint & 255;
      return {r: r, g: g, b: b};
    },
    /**
     * 根据节点的名字 去重
     */
    distinctNodeByName() {
      let nodeExists = [];
      let nodeIdExists = [];

      // 把渲染后的节点遍历 找出相同名字（重复的子节点）
      this.nodes.forEach((item) => {
        if (item.depth == 4) {
          //显示结果的节点不需要互相连线
          return;
        }
        // 如果集合中已经出现过这个名字
        if (nodeExists.includes(item.name)) {
          // 得到这个名字的id
          let number = nodeExists.indexOf(item.name);
          this.edges.forEach((e) => {
            // 找到对应的边
            if (e.source == item.pid && e.target == item.id) {
              // 创建一个新的 边的对象
              let addEdge = {};
              //重新赋值 边的 id = 开始节点的id + ':' + 目标节点的id
              addEdge.id = item.id + ":" + nodeIdExists[number];
              addEdge.source = item.id;
              addEdge.target = nodeIdExists[number];
              addEdge.type = "arc";
              addEdge.label = item.name;
              addEdge.style = {};
              // addEdge.sourceAnchor = 4;
              // addEdge.targetAnchor = 4;
              addEdge.style.stroke = this.colorArray[parseInt(item.id) % 3];
              // 添加新的线 指向这个重复出现的节点 第一次出现的位置
              this.graph.addItem("edge", addEdge);
              // 找到这节点 把它隐藏掉，对应的边也会隐藏
              // let hideNode = this.graph.findById(item.id);
              // this.graph.hideItem(hideNode);
            }
          });
        } else {
          // 将节点名字添加到集合中
          nodeExists.push(item.name);
          // 将节点id添加到集合中
          nodeIdExists.push(item.id);
        }
      });
    },

    /**
     * 深度第五层为结果， 结果显示的调整
     */
    depthFiveEdge() {
      if (this.showResultStatus) {
        this.nodes.forEach((item) => {
          if (item.depth == 4) {
            //根据这个节点的pid找到他的父节点的父节点
            let parentToNode = this.graph.findDataById(
              this.graph.findDataById(item.pid).pid
            );

            //根据 parentToNode的children 添加线
            for (let i = 0; i < parentToNode.children.length; i++) {
              if (i != 0) {
                let drawerEdge = {
                  id:
                    parentToNode.children[i].id +
                    ":" +
                    "result" +
                    parentToNode.id,
                  source: parentToNode.children[i].id,
                  target: "result" + parentToNode.id,
                };
                this.graph.addItem("edge", drawerEdge);
              }
            }
          }
        });
      }
    },
    /**
     * 数据初始化
     */
    init() {
      this.loading = true;
      userapi.getRequest("/chachong/getFlowAll", {}).then((res) => {
        let mockData = res.data.treeList[0];
        let statusList = res.data.statusList;
        /**
         * 生成给定长度的随机颜色
         */
        let generateColorArray = this.generateColorArray(statusList.length);
        this.colorArray = this.generateColorArray(10);
        let colors = {};

        for (let i = 0; i < statusList.length; i++) {
          colors[statusList[i]] = generateColorArray[i];
        }


        //  组件props
        const props = {
          data: mockData,
          config: {
            padding: [20, 50],
            defaultLevel: 3,
            // defaultZoom: 0.8,
            modes: {default: ["zoom-canvas", "drag-canvas"]},
          },
        };

        const container = document.getElementById("container");
        const width = container.scrollWidth;
        const height = container.scrollHeight;

        // 默认配置
        const defaultConfig = {
          width,
          height,
          modes: {
            default: ["zoom-canvas", "drag-canvas"],
          },
          fitView: true,
          animate: true,
          defaultNode: {
            type: "flow-rect",
          },
          defaultEdge: {
            type: "cubic-horizontal",
            style: {
              stroke: "#CED4D9",
            },
          },
          layout: {
            type: "indented",
            direction: "LR",
            dropCap: false,
            indent: 300,
            getHeight: () => {
              return 60;
            },
          },
        };

        // 自定义节点、边
        const registerFn = () => {
          /**
           * 自定义节点
           */
          G6.registerNode(
            "flow-rect",
            {
              shapeType: "flow-rect",
              draw(cfg, group) {
                const {
                  name = "",
                  paramValue,
                  // label,
                  collapsed,
                  status,
                } = cfg;

                const grey = "#CED4D9";
                const rectConfig = {
                  width: 202,
                  height: 60,
                  lineWidth: 1,
                  fontSize: 12,
                  fill: "#fff",
                  radius: 4,
                  stroke: grey,
                  opacity: 1,
                };

                const nodeOrigin = {
                  x: -rectConfig.width / 2,
                  y: -rectConfig.height / 2,
                };

                const rect = group.addShape("rect", {
                  attrs: {
                    x: nodeOrigin.x,
                    y: nodeOrigin.y,
                    width: 202,
                    height: 60,
                    lineWidth: 1,
                    fontSize: 12,
                    fill: "#fff",
                    radius: 4,
                    stroke: grey,
                    opacity: 1,
                    cursor: "pointer",
                  },
                  name: "rect-shape",
                  modelId: cfg.id,
                });

                const rectBBox = rect.getBBox();

                // label title
                group.addShape("text", {
                  attrs: {
                    textAlign: "left",
                    textBaseline: "middle",
                    x: 10 + nodeOrigin.x,
                    y: 20 + nodeOrigin.y,
                    text: name.length > 9 ? name.substr(0, 9) + "..." : name,
                    fontSize: 18,
                    opacity: 0.85,
                    fill: "#000",
                    cursor: "pointer",
                  },
                  name: "name-shape",
                  modelId: cfg.id,
                });

                // percentage
                const percentText = group.addShape("text", {
                  attrs: {
                    textBaseline: "bottom",
                    x: rectBBox.maxX - 8,
                    y: rectBBox.maxY - 12,
                    // text: paramValue == null ? null : `${paramValue.toFixed(2)}`,
                    text: cfg.depth == 3 || cfg.depth == 4 ? paramValue : null,
                    fontSize: 14,
                    textAlign: "right",
                    fill: "#000000",
                    cursor: "pointer",
                  },
                  name: "param-value-shape",
                  modelId: cfg.id,
                });

                // 底部的颜色
                const bottomRect = group.addShape("rect", {
                  attrs: {
                    x: nodeOrigin.x,
                    y: rectBBox.maxY - 4,
                    width: rectBBox.width - 2,
                    height: 4,
                    radius: [0, 0, 0, rectConfig.radius],
                    fill: colors[status],
                  },
                });

                // collapse rect
                if (cfg.children && cfg.children.length && cfg.depth != 3) {
                  group.addShape("rect", {
                    attrs: {
                      x: rectConfig.width / 2 - 8,
                      y: -8,
                      width: 16,
                      height: 16,
                      stroke: "rgba(0, 0, 0, 0.25)",
                      cursor: "pointer",
                      fill: "#fff",
                    },
                    name: "collapse-back",
                    modelId: cfg.id,
                  });

                  // collpase text
                  group.addShape("text", {
                    attrs: {
                      x: rectConfig.width / 2,
                      y: -1,
                      textAlign: "center",
                      textBaseline: "middle",
                      text: collapsed ? "+" : "-",
                      fontSize: 16,
                      cursor: "pointer",
                      fill: "rgba(0, 0, 0, 0.25)",
                    },
                    name: "collapse-text",
                    modelId: cfg.id,
                  });
                }

                this.drawLinkPoints(cfg, group);
                return rect;
              },
              update(cfg, item) {
                const {level, status, name} = cfg;
                const group = item.getContainer();
                let mask = group.find(
                  (ele) => ele.get("name") === "mask-shape"
                );
                let maskLabel = group.find(
                  (ele) => ele.get("name") === "mask-label-shape"
                );
                if (level === 0) {
                  group.get("children").forEach((child) => {
                    if (
                      child.get("name") &&
                      child.get("name").includes("collapse")
                    )
                      return;
                    child.hide();
                  });
                  if (!mask) {
                    mask = group.addShape("rect", {
                      attrs: {
                        x: -101,
                        y: -30,
                        width: 202,
                        height: 60,
                        opacity: 0,
                        fill: colors[status],
                      },
                      // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
                      name: "mask-shape",
                    });
                    maskLabel = group.addShape("text", {
                      attrs: {
                        fill: "#fff",
                        fontSize: 20,
                        x: 0,
                        y: 10,
                        text: name.length > 28 ? name.substr(0, 16) + "..." : name,
                        textAlign: "center",
                        opacity: 0,
                      },
                      // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
                      name: "mask-label-shape",
                    });
                    const collapseRect = group.find(
                      (ele) => ele.get("name") === "collapse-back"
                    );
                    const collapseText = group.find(
                      (ele) => ele.get("name") === "collapse-text"
                    );
                    if (collapseRect) {
                      collapseRect.toFront();
                    }
                    if (collapseText) {
                      collapseText.toFront();
                    }
                  } else {
                    mask.show();
                    maskLabel.show();
                  }
                  mask.animate({opacity: 1}, 200);
                  maskLabel.animate({opacity: 1}, 200);
                  return mask;
                } else {
                  group.get("children").forEach((child) => {
                    if (
                      child.get("name") &&
                      child.get("name").includes("collapse")
                    )
                      return;
                    child.show();
                  });
                  if (mask) {
                    mask.animate(
                      {opacity: 0},
                      {
                        duration: 200,
                        callback: () => mask.hide(),
                      }
                    );
                  }
                  if (maskLabel) {
                    maskLabel.animate(
                      {opacity: 0},
                      {
                        duration: 200,
                        callback: () => maskLabel.hide(),
                      }
                    );
                  }
                }
                this.updateLinkPoints(cfg, group);
              },
              setState(name, value, item) {
                if (name === "collapse") {
                  const group = item.getContainer();
                  const collapseText = group.find(
                    (e) => e.get("name") === "collapse-text"
                  );
                  if (collapseText) {
                    if (!value) {
                      collapseText.attr({
                        text: "-",
                      });
                    } else {
                      collapseText.attr({
                        text: "+",
                      });
                    }
                  }
                }
              },
              getAnchorPoints() {
                return [
                  [0, 0.5],
                  [1, 0.5],
                ];
              },
            },
            "rect"
          );

          G6.registerEdge(
            "flow-cubic",
            {
              getControlPoints(cfg) {
                let controlPoints = cfg.controlPoints; // 指定controlPoints
                if (!controlPoints || !controlPoints.length) {
                  const {startPoint, endPoint, sourceNode, targetNode} = cfg;
                  const {
                    x: startX,
                    y: startY,
                    coefficientX,
                    coefficientY,
                  } = sourceNode ? sourceNode.getModel() : startPoint;
                  const {x: endX, y: endY} = targetNode
                    ? targetNode.getModel()
                    : endPoint;
                  let curveStart = (endX - startX) * coefficientX;
                  let curveEnd = (endY - startY) * coefficientY;
                  curveStart = curveStart > 40 ? 40 : curveStart;
                  curveEnd = curveEnd < -30 ? curveEnd : -30;
                  controlPoints = [
                    {x: startPoint.x + curveStart, y: startPoint.y},
                    {x: endPoint.x + curveEnd, y: endPoint.y},
                  ];
                }
                return controlPoints;
              },
              getPath(points) {
                const path = [];
                path.push(["M", points[0].x, points[0].y]);
                path.push([
                  "C",
                  points[1].x,
                  points[1].y,
                  points[2].x,
                  points[2].y,
                  points[3].x,
                  points[3].y,
                ]);
                return path;
              },
            },
            "single-line"
          );
        };

        registerFn();

        const {data} = props;

        const initGraph = (data) => {
          if (!data) {
            return;
          }
          const {onInit, config} = props;
          const tooltip = new G6.Tooltip({
            offsetX: 20,
            offsetY: 30,
            // 允许出现 tooltip 的 item 类型
            itemTypes: ["node"],
            // 自定义 tooltip 内容
            getContent: (e) => {
              const outDiv = document.createElement("div");
              const nodeName = e.item.getModel().info
                ? e.item.getModel().info
                : e.item.getModel().name;
              let formatedNodeName = "";
              for (let i = 0; i < nodeName.length; i++) {
                formatedNodeName = `${formatedNodeName}${nodeName[i]}`;
                if (i !== 0 && i % 20 === 0)
                  formatedNodeName = `${formatedNodeName}<br/>`;
              }
              outDiv.innerHTML = `${formatedNodeName}`;
              return outDiv;
            },
            shouldBegin: (e) => {
              if (
                e.target.get("name") === "name-shape" ||
                e.target.get("name") === "mask-label-shape"
              )
                return true;
              return false;
            },
          });
          this.graph = new G6.TreeGraph({
            container: "container",
            width,
            height,
            modes: {
              default: ["zoom-canvas", "drag-canvas"],
            },
            // fitView: true,
            // fitViewPadding: [0, 0, 0, -1350],
            animate: false,
            defaultNode: {
              type: "flow-rect",
            },
            defaultEdge: {
              type: "cubic-horizontal",
              style: {
                stroke: "#CED4D9",
              },
            },
            layout: {
              type: "indented",
              direction: "LR",
              dropCap: false,
              indent: 300,
              getHeight: () => {
                return 60;
              },
            },
            padding: [20, 50],
            defaultLevel: 3,
            defaultZoom: 0.5,
            // minZoom: 1,
            // maxZoom: 1,
            // modes: { default: ['zoom-canvas', 'drag-canvas'] },
            plugins: [tooltip],
          });
          if (typeof onInit === "function") {
            onInit(this.graph);
          }
          this.graph.data(data);
          this.graph.render();

          const handleCollapse = (e) => {
            const target = e.target;
            const id = target.get("modelId");
            const item = this.graph.findById(id);
            const nodeModel = item.getModel();
            let map = this.graph.getNodes().map((node) => node.getModel());
            map.forEach((item) => {
              // 移出当前的结果节点
              if (
                item.depth == 4 &&
                this.graph.findDataById(item.pid).pid == nodeModel.id
              ) {
                this.graph.removeChild(item.id);
              }
            });
            nodeModel.collapsed = !nodeModel.collapsed;
            this.graph.layout();
            this.graph.setItemState(item, "collapse", nodeModel.collapsed);

            this.graph.render();

            // 获取所有已经显示的节点数据
            this.nodes = this.graph.getNodes().map((node) => node.getModel());
            // 获取所有已经显示的边数据
            this.edges = this.graph.getEdges().map((edge) => edge.getModel());

            if (!nodeModel.collapsed) {
              console.log("!1111111")
              //展开的时候才显示结果
              this.initShowResult();
            }
            // 去掉重复的节点根据node.name
            // this.distinctNodeByName();
            this.depthFiveEdge();

            /*let nodeExists = [];
            let nodeIdExists = [];

            // 把渲染后的节点遍历 找出相同名字（重复的子节点）
            this.nodes.forEach(item => {
              // 如果集合中已经出现过这个名字
              if (nodeExists.includes(item.name)){
                // 得到这个名字的id
                let number = nodeExists.indexOf(item.name);
                this.edges.forEach(e => {
                  // 找到对应的边
                  if (e.source == item.pid && e.target == item.id){
                    // 创建一个新的 边的对象
                    let addEdge = e;
                    //重新赋值 边的 id = 开始节点的id + ':' + 目标节点的id
                    addEdge.id = item.pid + ':' + nodeIdExists[number];
                    addEdge.source = item.pid;
                    addEdge.target = nodeIdExists[number];
                    console.log("addEdge",addEdge);
                    // 添加新的线 指向这个重复出现的节点 第一次出现的位置
                    this.graph.addItem('edge', addEdge)
                    // 找到这节点 把它隐藏掉，对应的边也会隐藏
                    let hideNode = this.graph.findById(item.id);
                    console.log("hideNode",hideNode)
                    this.graph.hideItem(hideNode);
                  }
                })
              }else {
                // 将节点名字添加到集合中
                nodeExists.push(item.name);
                // 将节点id添加到集合中
                nodeIdExists.push(item.id);
              }

            })*/
          };
          this.graph.on("collapse-text:click", (e) => {
            handleCollapse(e);
            const nodeModel = e.item.getModel();
            this.graph.zoomTo(1);
            this.graph.moveTo(400 - 300 * nodeModel.depth, 150 - nodeModel.y, {animate: true});
          });

          // 给节点矩形添加点击事件
          this.graph.on("rect-shape:click", (e) => {
            if (this.graph.findById(e.target.get("modelId")).getModel().depth == 2) {
              this.openDrawer(e.target.get("modelId"));
            }
          });
          // 给节点 name区域 添加点击事件
          this.graph.on("name-shape:click", (e) => {
            if (this.graph.findById(e.target.get("modelId")).getModel().depth == 2) {
              this.openDrawer(e.target.get("modelId"));
            }
          });

          // 深度为3 整个矩形 的移入移出事件
          this.graph.on("rect-shape:mouseenter", (e) => {
            if (this.graph.findById(e.target.get("modelId")).getModel().depth == 3) {
              // 获取所有已经显示的节点数据
              this.nodes = this.graph.getNodes().map((node) => node.getModel());
              // 获取所有已经显示的边数据
              this.edges = this.graph.getEdges().map((edge) => edge.getModel());
              this.depthThreeSameNodeActive(e.target.get("modelId"), true);
            }
          });
          this.graph.on("rect-shape:mouseleave", (e) => {
            if (this.graph.findById(e.target.get("modelId")).getModel().depth == 3) {
              // 获取所有已经显示的节点数据
              this.nodes = this.graph.getNodes().map((node) => node.getModel());
              // 获取所有已经显示的边数据
              this.edges = this.graph.getEdges().map((edge) => edge.getModel());
              this.depthThreeSameNodeActive(e.target.get("modelId"), false);
            }
          });
          this.graph.on('node:click', (e) => {
            const nodeModel = e.item.getModel();
            if (nodeModel.depth <= 2) {
              handleCollapse(e);
            }
            this.graph.zoomTo(1);
            this.graph.moveTo(400 - 300 * nodeModel.depth, 150 - nodeModel.y, {animate: true});
          });

          let menu1 = null;
          let menu2 = null;

          this.graph.on('node:contextmenu', (e) => {
            const nodeModel = e.item.getModel();
            if (nodeModel.depth == 2) {
              e.preventDefault(); // 阻止浏览器的默认行为
              this.hideContextMenu(this.menu); // 隐藏之前的菜单
              this.menu = this.createContextMenu1(nodeModel); // 创建自定义的右键菜单
              container.appendChild(this.menu); // 将菜单添加到画布的容器元素中
              this.menu.show(e.clientX + 10, e.clientY -60); // 在鼠标点击位置显示右键菜单
            }
            if (nodeModel.depth == 3) {
              e.preventDefault(); // 阻止浏览器的默认行为
              this.hideContextMenu(this.menu); // 隐藏之前的菜单
              this.menu = this.createContextMenu2(nodeModel); // 创建自定义的右键菜单
              container.appendChild(this.menu); // 将菜单添加到画布的容器元素中
              this.menu.show(e.clientX + 10, e.clientY -60); // 在鼠标点击位置显示右键菜单
            }
          });

          //深度不为4的显示结果区域的点击事情
          this.graph.on("param-value-shape:click", (e) => {
            if (this.graph.findById(e.target.get("modelId")).getModel().depth != 4) {
              this.openDialog(e.target.get("modelId"));
            }
          });

          /*// 监听画布缩放，缩小到一定程度，节点显示缩略样式
          let currentLevel = 1;
          const briefZoomThreshold = Math.max(this.graph.getZoom(), 0.5);
          this.graph.on("viewportchange", (e) => {
            if (e.action !== "zoom") return;
            const currentZoom = this.graph.getZoom();
            let toLevel = currentLevel;
            if (currentZoom < briefZoomThreshold) {
              toLevel = 0;
            } else {
              toLevel = 1;
            }
            if (toLevel !== currentLevel) {
              currentLevel = toLevel;
              this.graph.getNodes().forEach((node) => {
                this.graph.updateItem(node, {
                  level: toLevel,
                });
              });
            }
          });*/
        };

        initGraph(data);

        // 获取所有已经显示的节点数据
        this.nodes = this.graph.getNodes().map((node) => node.getModel());
        // 获取所有已经显示的边数据
        this.edges = this.graph.getEdges().map((edge) => edge.getModel());

        this.initShowResult();
        // this.distinctNodeByName();
        this.depthFiveEdge();
        this.graph.zoomTo(1);
        this.graph.moveTo(400 - 300 * 0, 150 - 0, {animate: true});


        if (typeof window !== "undefined") {
          window.onresize = () => {
            if (!this.graph || this.graph.get("destroyed")) return;
            if (!container || !container.scrollWidth || !container.scrollHeight)
              return;
            this.graph.changeSize(
              container.scrollWidth,
              container.scrollHeight
            );
          };
        }
        this.loading = false;
      });
    },
    // 创建自定义的右键菜单
    createContextMenu1(nodeModel) {
      this.menu = document.createElement('div');
      this.menu.style.position = 'absolute';
      this.menu.style.backgroundColor = 'rgb(255,255,255)';
      this.menu.style.border = '1px solid #ccc';
      this.menu.style.padding = '5px';
      this.menu.style.borderRadius = '5px';
      this.menu.style.marginBottom = '5px';

      // 添加菜单项
      if (nodeModel.depth == 2) {
        const menuItem1 = document.createElement('div');
        menuItem1.innerHTML = '新增参数';
        // menuItem1.style.backgroundColor = '#31b7fc';
        menuItem1.style.borderRadius = '5px';
        menuItem1.addEventListener('click', () => {
          // 菜单项1的点击事件处理程序
          this.addChildrenNodeStatus = true;
          this.addCurrentNode = nodeModel;

          this.addNodeGongShi = nodeModel.gongShi;
          this.addNodeRestExpression = nodeModel.restExpression;
          this.hideContextMenu(this.menu)
        });
        this.menu.appendChild(menuItem1);
      }

      const hr = document.createElement('hr');
      this.menu.appendChild(hr);

      const menuItem2 = document.createElement('div');
      menuItem2.innerHTML = '修改公式';
      menuItem2.addEventListener('click', () => {
        // 菜单项2的点击事件处理程序
        this.updateNodeGongShiStatus = true;
        this.updateCurrentNode = nodeModel;
        this.hideContextMenu(this.menu)
      });
      this.menu.appendChild(menuItem2);

      // 隐藏菜单
      this.menu.hide = () => {
        this.menu.style.display = 'none';
      };

      // 显示菜单
      this.menu.show = (x, y) => {
        this.menu.style.left = x + 'px'; // 设置菜单的水平位置
        this.menu.style.top = y + 'px'; // 设置菜单的垂直位置
        this.menu.style.display = 'block';
      };

      // 点击菜单外部区域时隐藏菜单
      document.addEventListener('click', (e) => {
        if (!this.menu.contains(e.target)) {
          this.menu.hide();
        }
      });
      return this.menu;
    },
    // 创建自定义的右键菜单
    createContextMenu2(nodeModel) {
      this.menu = document.createElement('div');
      this.menu.style.position = 'absolute';
      this.menu.style.backgroundColor = '#fff';
      this.menu.style.border = '1px solid #ccc';
      this.menu.style.padding = '5px';
      this.menu.style.borderRadius = '5px';

      // 添加菜单项
      if (nodeModel.depth == 3) {
        const menuItem1 = document.createElement('div');
        menuItem1.innerHTML = '删除参数';
        // menuItem1.style.backgroundColor = '#e87820';
        menuItem1.addEventListener('click', () => {
          //删除当前参数 并将同级的参数节点id重新排序
          modelApi.deleteParamNode({node_name: nodeModel.param}).then((res) => {
            if (res.data.status == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            }
          })

          this.graph.removeChild(nodeModel.id)
          this.hideContextMenu(this.menu)
          this.initShowResult();
          this.graph.zoomTo(1);
          this.graph.moveTo(400 - 300 * nodeModel.depth, 150 - nodeModel.y, {animate: true});
        });
        this.menu.appendChild(menuItem1);
      }

      // 隐藏菜单
      this.menu.hide = () => {
        this.menu.style.display = 'none';
      };

      // 显示菜单
      this.menu.show = (x, y) => {
        this.menu.style.left = x + 'px'; // 设置菜单的水平位置
        this.menu.style.top = y + 'px'; // 设置菜单的垂直位置
        this.menu.style.display = 'block';
      };

      // 点击菜单外部区域时隐藏菜单
      document.addEventListener('click', (e) => {
        if (!this.menu.contains(e.target)) {
          this.menu.hide();
        }
      });
      return this.menu;
    },
    // 隐藏菜单
    hideContextMenu(menu) {
      if (menu) {
        menu.remove(); // 从DOM中移除菜单元素
        menu = null; // 清空菜单变量
      }
    }
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
    this.init();
  }
};
</script>
<style scoped>
.contain {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  text-align: left;
  position: relative;
  /*background-color: #C6B982;*/
}

.drawerClass {
  display: flex;
  flex-direction: row;
  justify-self: left;
}

>>> .el-drawer__header {
  color: black;
  font-size: 22px;
}

>>> .dialogClass .el-dialog__body {
  padding: 0px 20px 10px 20px;
}

.rowClass {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.rowClass .el-input {
  width: 70%;
}

>>> .rowClass .el-input .el-input__inner {
  width: 100%;
}

>>> .el-textarea {
  width: 70%;
}

.submitClass {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

>>> .submitClass .el-button {
  padding: 8px 15px;
}

.aaa /deep/ .el-drawer {
  text-align: left !important;
  position: absolute;
  top: 60px;
  height: calc(100vh - 60px);
  padding-left: 20px;
}

>>> #el-drawer__title {
  padding-left: 0px;
}

>>> .drawerHeader .el-drawer__header > :first-child {
  flex: none;
}

>>> .drawerHeader .el-button {
  padding: 10px 12px;
}

.positionLeft {
  position: absolute;
  top: 0;
  left: 0;
}

.positionRight {
  position: absolute;
  right: 0;
  top: 0;
}


.absoluteClass {
  position: absolute;
  width: 100%;
  top: 2px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.searchDivClass {
  display: flex;
  flex-direction: row;
}


</style>



// WEBPACK FOOTER //
// src/components/flowcount.vue